"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = '0.12.5';
